export default "__VITE_ASSET__tjz5y6R___"